/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  Row,
  Layout,
  Select,
  Skeleton,
  Table,
  Tabs,
  Tooltip,
  Modal,
  Radio,
  Upload,
  Typography,
  notification,
  Empty,
} from 'antd';
import {
  DeleteOutlined,
  DownloadOutlined,
  DownOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { Truck, FileDown } from 'lucide-react';
import { Button as CrcButton } from '@crc-evans/ui-components';
import { connect } from 'react-redux';
import get from 'lodash/get';
import { OnGetShippingForm } from '../../redux/ShipmentDashboardDetails/saga';
import { Content } from 'antd/lib/layout/layout';
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const ShipmentLogs = (props) => {
  const { showFormModel, setShowFormModel, selectedData } = props;

  const [shipmentTypeList, setShipmentTypeList] = useState([
    'PSI (Pre-Shipment Inspection)',
    'SGR (Site Goods Received)',
  ]);
  const [shipmentLogsForm] = Form.useForm();
  const [formValues, setFormValues] = useState({});
  const [pSIQuestions, setPSIQuestion] = useState([]);
  const [sGRQuestions, setSGRQuestions] = useState([]);
  const [questions, setQuestion] = useState([]);
  const [selectedForm, setSelectedForm] = useState('PSI (Pre-Shipment Inspection)');
  const [loading, setAddLoading] = useState(false);
  const [reportUrl, setReportUrl] = useState(null);
  const [postSubmissionComment, setPostSubmissionComment] = useState('');
  const [postSubmissionImages, setPostSubmissionImages] = useState([]);
  const [psiPostData, setPsiPostData] = useState({ comment: '', images: [] });
  const [sgrPostData, setSgrPostData] = useState({ comment: '', images: [] });
  const scrollContainerRef = useRef();

  const renderPostSubmissionSection = () => {
    const images = Array.isArray(postSubmissionImages) ? postSubmissionImages : [];
    const hasComment = !!String(postSubmissionComment || '').trim();
    const hasImages = images.length > 0;
    if (!hasComment && !hasImages) return null;

    return (
      <div style={{ padding: '8px 0 16px', borderBottom: '1px solid #eee' }}>
        <Text strong>{'Post-submission update'}</Text>
        {hasComment ? (
          <div style={{ color: '#666', marginTop: 6, whiteSpace: 'pre-wrap' }}>
            {postSubmissionComment}
          </div>
        ) : null}
        {hasImages ? (
          <div style={{ marginTop: 12 }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                overflowX: 'auto',
                gap: 16,
                paddingTop: 6,
              }}
            >
              {images.map((img, i) => {
                const fileKey = img?.fileKey || img?.file_key || '';
                const fileName =
                  img?.fileName ||
                  img?.file_name ||
                  (fileKey ? String(fileKey).split('/').pop() : `image-${i + 1}`);
                const src =
                  img?.fileUrl ||
                  img?.file_url ||
                  img?.url ||
                  img?.publicUrl ||
                  (typeof fileKey === 'string' && fileKey.startsWith('http') ? fileKey : '');

                return (
                  <div
                    key={`post-image-${i}`}
                    style={{
                      width: 150,
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    {src ? (
                      <Image
                        src={src}
                        alt={fileName}
                        width={150}
                        height={100}
                        style={{ objectFit: 'cover', borderRadius: 4 }}
                      />
                    ) : (
                      <div
                        style={{
                          width: 150,
                          height: 100,
                          borderRadius: 4,
                          border: '1px dashed #ccc',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          color: '#999',
                          fontSize: 12,
                          textAlign: 'center',
                          padding: 8,
                        }}
                      >
                        {'Image (no URL)'}
                      </div>
                    )}
                    <Text style={{ fontSize: 12, marginTop: 6, textAlign: 'center' }}>
                      {fileName}
                    </Text>
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  const renderFormItem2 = (item, index) => {
    if (!item || !item.question) return null;

    const question = item.question;
    const answer = item.answer;
    const fileUrls = Array.isArray(item.file_urls) ? item.file_urls : [];
    if (question.text === 'Download PDF Report' && question.type === 'upload') {
      if (!reportUrl && fileUrls.length > 0) setReportUrl(fileUrls.length > 0 ? fileUrls[0] : '');
      return null;
    }
    if (question.text === 'Submitted By') return null;

    const labelStyle = { fontSize: '18px', fontWeight: 500 };
    const contentStyle = { paddingRight: '20px', borderBottom: '1px solid #eee' }; // right padding for answers and uploads

    switch (question.type) {
      case 'textInput':
      case 'radioButton':
        return (
          <Form.Item
            key={question.id}
            label={<span style={labelStyle}>{`${index}. ${question.text}`}</span>}
            name={`question_${question.id}`}
          >
            <div style={contentStyle}>
              <span>{answer || 'No answer provided'}</span>
            </div>
          </Form.Item>
        );

      case 'upload':
        const imageExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
        const imageFiles = fileUrls?.filter((url) => imageExtensions.test(url)) || [];
        const otherFiles = fileUrls?.filter((url) => !imageExtensions.test(url)) || [];

        // Special rendering for Signature (handled outside Form.Item)
        if (question.text === 'Signature' && imageFiles.length > 0) {
          const submittedByQuestion = questions.find((q) => q.question.text === 'Submitted By');
          const submittedByName = submittedByQuestion?.answer;

          return (
            <div
              key={`signature-${question.id}`}
              style={{ marginTop: 32 }}
            >
              <Text strong>{`Submitted By : ${submittedByName}`}</Text>
              <div style={{ paddingTop: 12, textAlign: 'center' }}>
                <Image
                  src={imageFiles[0]}
                  alt="Signature"
                  width={200}
                  preview={false} // 👈 disables preview popup on hover
                  style={{ display: 'inline-block' }}
                />
                {submittedByName && (
                  <div style={{ marginTop: 8 }}>
                    <Text>{'Signature'}</Text>
                  </div>
                )}
              </div>
            </div>
          );
        }

        // Standard upload field
        return (
          <Form.Item
            key={question.id}
            label={<span style={labelStyle}>{`${index}. ${question.text}`}</span>}
            name={`question_${question.id}`}
          >
            <div style={contentStyle}>
              {imageFiles.length > 0 || otherFiles.length > 0 ? (
                <>
                  {imageFiles.length > 0 && (
                    <div style={{ marginTop: 16 }}>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'nowrap',
                          overflowX: 'auto',
                          gap: 16,
                          paddingTop: 12,
                        }}
                      >
                        {imageFiles.map((url, i) => {
                          const fileName = url.split('/').pop();
                          return (
                            <div
                              key={`image-${i}`}
                              style={{
                                width: 150,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <Image
                                src={url}
                                alt={fileName}
                                width={150}
                                height={100}
                                style={{ objectFit: 'cover', borderRadius: 4 }}
                              />
                              <Text
                                style={{
                                  fontSize: '12px',
                                  marginTop: 6,
                                  textAlign: 'center',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                {fileName}
                                <Tooltip title="Download">
                                  <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <DownloadOutlined
                                      className="heatIcon"
                                      style={{ fontSize: '16px', marginTop: 4 }}
                                    />
                                  </a>
                                </Tooltip>
                              </Text>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {otherFiles.map((url, i) => {
                    const fileName = url.split('/').pop();
                    return (
                      <Row
                        key={`file-${i}`}
                        align="middle"
                        justify="space-between"
                        style={{ marginBottom: 8 }}
                      >
                        <Col span={18}>
                          <Text style={{ fontSize: '12px' }}>{`${i + 1}. ${fileName}`}</Text>
                        </Col>
                        <Col
                          span={6}
                          style={{ textAlign: 'right' }}
                        >
                          <Tooltip
                            title="Download"
                            arrowPointAtCenter
                          >
                            <a
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <DownloadOutlined
                                className="heatIcon"
                                style={{ fontSize: '16px' }}
                              />
                            </a>
                          </Tooltip>
                        </Col>
                      </Row>
                    );
                  })}
                </>
              ) : (
                <span>No files uploaded</span>
              )}
            </div>
          </Form.Item>
        );

      default:
        return null;
    }
  };
  useEffect(() => {
    if (selectedData && selectedData.submissions?.length > 0) {
      //console.log(selectedData)
      const fetchShippingForms = async () => {
        try {
          setAddLoading(true);

          const psiSubmission = selectedData.submissions.find(
            (item) => item.formType === 'Pre-Shipment Inspection'
          );
          const sgrSubmission = selectedData.submissions.find(
            (item) => item.formType === 'Site Goods Received'
          );

          let psiAnswers = [];
          let sgrAnswers = [];

          if (psiSubmission?.id) {
            const psiRes = await OnGetShippingForm(psiSubmission.id);
            psiAnswers = Array.isArray(psiRes?.answers) ? psiRes.answers
              : Array.isArray(psiRes) ? psiRes : [];
            const psiComment = psiRes?.post_submission_comment || '';
            const psiImages = Array.isArray(psiRes?.post_submission_images) ? psiRes.post_submission_images : [];
            if (psiAnswers.length > 0) {
              setPSIQuestion(psiAnswers);
              setQuestion(psiAnswers);
              setSelectedForm('PSI (Pre-Shipment Inspection)');
              setPsiPostData({ comment: psiComment, images: psiImages });
              setPostSubmissionComment(psiComment);
              setPostSubmissionImages(psiImages);
            }
          }

          if (sgrSubmission?.id) {
            const sgrRes = await OnGetShippingForm(sgrSubmission.id);
            sgrAnswers = Array.isArray(sgrRes?.answers) ? sgrRes.answers
              : Array.isArray(sgrRes) ? sgrRes : [];
            const sgrComment = sgrRes?.post_submission_comment || '';
            const sgrImages = Array.isArray(sgrRes?.post_submission_images) ? sgrRes.post_submission_images : [];
            if (sgrAnswers.length > 0) {
              setSGRQuestions(sgrAnswers);
              setSgrPostData({ comment: sgrComment, images: sgrImages });

              // If no PSI data was found, use SGR
              if (psiAnswers.length === 0) {
                setQuestion(sgrAnswers);
                setSelectedForm('SGR (Site Goods Received)');
                setPostSubmissionComment(sgrComment);
                setPostSubmissionImages(sgrImages);
                shipmentLogsForm.setFieldValue('shipmentType', 'SGR (Site Goods Received)');
              }
            }
          }

          setAddLoading(false);
        } catch (error) {
          console.error('Failed to fetch shipping forms:', error);
          setAddLoading(false);
        }
      };

      fetchShippingForms();
    }
  }, [selectedData]);

  /** Handle PDF download from uploaded file */
  const handleOk = async () => {
    const downloadItem = questions.find(
      (item) =>
        item.question?.text === 'Download PDF Report' &&
        item.question?.type === 'upload' &&
        Array.isArray(item.file_urls) &&
        item.file_urls.length > 0
    );

    if (downloadItem) {
      const reportUrl = downloadItem.file_urls[0];

      const anchor = document.createElement('a');
      anchor.href = reportUrl;
      anchor.rel = 'noopener noreferrer';
      anchor.target = '_blank';
      anchor.download = `${selectedForm || 'report'}.pdf`; // fallback filename
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } else {
      console.warn('No downloadable PDF found in the questions.');
    }
  };

  /** Resetting values on Closing Modal */
  const handleCancel = async () => {
    setShowFormModel(false);

    shipmentLogsForm.resetFields();
  };
  // useEffect(() => {
  //     console.log(formValues, questions)

  // }, [questions])

  const handleShippingFormChanged = (value) => {
    setAddLoading(true);
    setReportUrl(null);
    setSelectedForm(value);

    if (value === 'PSI (Pre-Shipment Inspection)') {
      setQuestion(pSIQuestions && pSIQuestions.length > 0 ? pSIQuestions : []);
      setPostSubmissionComment(psiPostData.comment);
      setPostSubmissionImages(psiPostData.images);
    } else {
      setQuestion(sGRQuestions && sGRQuestions.length > 0 ? sGRQuestions : []);
      setPostSubmissionComment(sgrPostData.comment);
      setPostSubmissionImages(sgrPostData.images);
    }
    setAddLoading(false);
  };

  return (
    <div>
      <Modal
        className="heatprofile-modal"
        title={
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '95%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Truck size={20} color="#ef314c" />
              <span>Shipment History - {selectedData?.shipmentNumber}</span>
            </div>
            {selectedForm && (
              <CrcButton
                label="Download Report"
                variant="secondary"
                icon={FileDown}
                onClick={() => handleOk()}
                size="medium"
              />
            )}
          </div>
        }
        centered
        width={1000}
        bodyStyle={{ padding: 0, overflow: 'visible' }}
        visible={showFormModel}
        onCancel={handleCancel}
        footer={[
          <Button key="cancel" onClick={handleCancel}>Close</Button>,
        ]}
      >
        {!loading ? (
          <div
            className="equipment_logs"
            style={{ paddingTop: '5px' }}
          >
            <>
              <Form
                form={shipmentLogsForm}
                name="basic"
                layout="vertical"
                autoComplete="off"
                getContainer={false}
              // onValuesChange={(changed, all) => {

              //     const key = Object.keys(changed)[0];
              //     const value = changed[key];
              //     console.log(key, value)
              //     // Update formValues
              //     setFormValues((prev) => ({
              //         ...prev,
              //         [key]: value
              //     }));

              //     // Update the answer_text in the corresponding question
              //     const updatedQuestions = questions.map((q) => {
              //         const questionKey = `question_${q.sno}`;
              //         if (questionKey === key) {
              //             return {
              //                 ...q,
              //                 answer_text: value // this is your target update
              //             };
              //         }
              //         return q;
              //     });

              //     // console.log(formValues, questions)

              //     setQuestion(updatedQuestions);
              // }}
              >
                <Row
                  gutter={24}
                  className=""
                >
                  <Col lg={24}>
                    <Form.Item
                      name="shipmentType"
                      required
                    >
                      <div>
                        <Select
                          className="maintenance-select"
                          placeholder={'Select Shipping Form'}
                          getPopupContainer={(trigger) => trigger.parentNode}
                          dropdownClassName="heat-profile-select-dropdown"
                          showSearch
                          // allowClear
                          optionFilterProp="children"
                          onChange={handleShippingFormChanged}
                          size="large"
                          value={selectedForm}
                        >
                          {shipmentTypeList &&
                            shipmentTypeList.map((item, i) => (
                              <Option
                                key={i}
                                value={item}
                              >
                                {item}
                              </Option>
                            ))}
                        </Select>
                      </div>
                    </Form.Item>
                  </Col>
                </Row>
                {
                  <Layout
                    style={{
                      height: '600px', // Fixed height
                      width: '100%',
                    }}
                  >
                    <Content
                      style={{
                        height: '100%',
                        backgroundColor: 'transparent',
                        padding: '20px',
                        boxSizing: 'border-box',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        WebkitOverflowScrolling: 'touch',
                        scrollBehavior: 'smooth',
                      }}
                    >
                      {loading ? (
                        <div
                          style={{
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <Table loading={loading} />
                        </div>
                      ) : !questions ||
                        questions.length === 0 ||
                        (questions.length === 1 &&
                          !questions[0].form_type &&
                          !questions[0].form_id) ? (
                        <div
                          style={{
                            height: '100%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: 20,
                            color: '#999',
                          }}
                        >
                          No submitted form
                        </div>
                      ) : (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 12,
                            width: '100%',
                            minHeight: '100%',
                          }}
                        >
                          {(() => {
                            const sigIdx = Array.isArray(questions)
                              ? questions.findIndex((q) => q?.question?.text === 'Signature')
                              : -1;
                            const hasSig = sigIdx >= 0;
                            const before = hasSig ? questions.slice(0, sigIdx) : questions;
                            const after = hasSig ? questions.slice(sigIdx) : [];
                            return (
                              <>
                                {before.map((q, index) => renderFormItem2(q, index + 1))}
                                {hasSig ? renderPostSubmissionSection() : null}
                                {hasSig
                                  ? after.map((q, index) =>
                                      renderFormItem2(q, before.length + index + 1)
                                    )
                                  : null}
                              </>
                            );
                          })()}
                        </div>
                      )}
                    </Content>
                  </Layout>
                }
              </Form>
            </>
          </div>
        ) : (
          <div>{loading ? <Table loading={loading} /> : <Empty />}</div>
        )}
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ equip }) => {
  return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentLogs);
